import {
  ChangeDetectionStrategy,
  Component,
  Host,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {BacklogActivity} from '../../../../../data/engineering/backlog-activity';
import {ProjectInfoComponent} from '../../../../../../../../../../mobile/src/app/modules/project/view/project-info/project-info.component';
import {ProjectWindowComponent} from '../../../../../../../../../../desktop/src/app/modules/project/view/project-window/project-window.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {ProjectService} from '../../../../../../project-misc/data/project/project.service';
import {MatDialog} from '@angular/material/dialog';
import {DOCUMENT} from '@angular/common';
import {Project} from '../../../../../../project-misc/data/project/project';
import {ProjectActivityService} from '../../../../../../project-misc/data/project/activity/project-activity.service';
import {NgForm} from '@angular/forms';
import {debounceTime, distinctUntilChanged, filter, skip} from 'rxjs/operators';
import {ProjectActivity} from '../../../../../../project-misc/data/project/activity/project-activity';
import {EngineeringColumnComponent} from '../engineering-column.component';
import {ActivityEngineeringService} from '../../../../../data/activity-engineering.service';
import {Subject, Subscription} from 'rxjs';

@Component({
  selector: 'app-engineering-tile',
  templateUrl: './engineering-tile.component.html',
  styleUrls: ['./engineering-tile.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EngineeringTileComponent implements OnInit, OnDestroy {
  @Input()
  tile: BacklogActivity;
  @Input()
  isMobile: boolean;

  @Input()
  showUser: boolean;
  @Input()
  showStatusChangeReason: boolean;
  project: Project;
  today: Date = new Date();
  @ViewChild('editForm', {static: false})
  editForm: NgForm;
  private originalReason: string;

  private destroy$ = new Subject<void>();
  private sub: Subscription;
  constructor(
      @Inject(DOCUMENT) private document: Document,
      protected dialog: MatDialog,
      private deviceService: DeviceDetectorService,
      protected projectService: ProjectService,
      protected projectActivityService: ProjectActivityService,
      protected engineeringService: ActivityEngineeringService,
      @Host() private host: EngineeringColumnComponent
      ) {
  }

  ngOnInit(): void {
    this.sub = this.engineeringService.commandStream$
        .pipe(filter(cmd => cmd.id === this.tile.id))
        .subscribe(cmd => {
          console.log('cmd', cmd)
          if (cmd.action === 'move') this.movedToOnHold();
        });
  }

  @HostListener('click', ['$event'])
  public onMousedown(event: MouseEvent) {
    this.openProjectWindow(this.tile.jobId)
  }

  movedToOnHold() {
    this.startEditing(null)
  }

  startEditing(event: MouseEvent) {
    if (event !== null) {
      event.stopPropagation();
    }
    this.originalReason = this.tile.statusChangeReason;
    this.tile.isEditing = true;

    setTimeout(() => {
      const textarea = this.document.querySelector('.item-box .collapsable-block textarea.status-reason-input') as HTMLTextAreaElement;
      if (textarea) {
        const width = textarea.parentElement.parentElement.parentElement.clientWidth - 10;
        textarea.style.width = `${width}px`;
        textarea.style.maxWidth = `${width}px`;
        textarea.style.minWidth = `${width}px`;

        textarea.style.height = 'auto';
        textarea.style.overflowY = 'hidden';
        textarea.style.height = `${textarea.scrollHeight + 15}px`;

        textarea.focus();
      }
    }, 10)
  }

  stopEditing() {
    this.tile.isEditing = false;
    if (this.tile.statusChangeReason !== this.originalReason) {
      this.saveActivity();
    }
  }

  cancelEditing() {
    this.tile.statusChangeReason = this.originalReason;
    this.tile.isEditing = false;
  }

  openProjectWindow(projectId: number) {
    let dialogRef
    if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
      dialogRef = this.dialog.open(ProjectInfoComponent, {
        data: {
          projectNumber: projectId
        },
        panelClass: 'project-info-dialog'
      });
    }
    else {
      dialogRef = this.dialog.open(ProjectWindowComponent, {
        data: {
          projectNumber: projectId,
        },
        panelClass: 'project-window-dialog'
      });
    }

    dialogRef.afterOpened().subscribe(result => {
      this.document.body.classList.add('disable-scroll')
    });


    dialogRef.afterClosed().subscribe(result => {
      this.projectService.getProject(this.tile.jobId).subscribe(project => {
        if (project) {
          this.project = project;
        }
      })

      this.document.body.classList.remove('disable-scroll')
    });
  }

  saveActivity() {
    const data = {
      id: this.tile.id,
      statusChangeReason: this.tile.statusChangeReason.substring(0, 250).trim(),
    } as ProjectActivity;
    this.projectActivityService.saveProjectActivity(data).subscribe(() => {
      this.editForm.resetForm();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.sub) {
      this.sub.unsubscribe();
      this.sub = null;
    }
  }

}
